import React from 'react';
import './Login.css'; // Make sure to create this CSS file
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../utils/Loader';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { setData } from '../redux/actions/DataAction';
import ApiServices from '../config/ApiServices';
import { showLoader, hideLoader } from '../redux/actions/LoaderActions'; // import actions

export default function Login() {
    const loading = useSelector((state) => state.loader.loading);
    const { register, reset, handleSubmit } = useForm();
    const dispatch = useDispatch();
    const nav = useNavigate();

    const handleForm = (data) => {
        dispatch(showLoader()); // show loader before API call
        ApiServices.apiRequest("login", data)
            .then((res) => {
                if (res.data.success) {
                    toast.success(res.data.message);
                    let userData = res.data.data;
                    sessionStorage.setItem("userRole", userData.role);
                    sessionStorage.setItem("userName", userData.name);
                    sessionStorage.setItem("email", userData.email);
                    sessionStorage.setItem("userId", userData._id);
                    sessionStorage.setItem("token", res.data.token);
                    sessionStorage.setItem("isLogin", true);
                    if (userData.role == 1) {
                        nav("/admin");
                    } else if (userData.role == 2) {
                        nav("/trainer");
                    } else {
                        nav("/student");
                    }
                } else {
                    toast.error(res.data.message);
                    dispatch(showLoader()); 
                    setTimeout(() => dispatch(hideLoader()), 2000); 
                }
            })
            .catch((err) => {
                toast.error(err?.message);
                dispatch(showLoader()); 
                setTimeout(() => dispatch(hideLoader()), 2000); 
            })
            .finally(() => {
                if (!loading) {
                    dispatch(hideLoader());
                }
            });
    };

    const handleError = (errors) => {
        toast.error("Error in form");
        dispatch(showLoader()); 
        setTimeout(() => dispatch(hideLoader()), 2000); 
    };

    return (
        <div className="container-fluid login login-background">
            <div className="row min-vh-100 justify-content-center align-items-center">
                <div className="col-md-6 px-5">
                    <div className="card p-5 shadow-lg">
                        <h1 className="text-center text-light">Login</h1>
                        <form method='post' onSubmit={handleSubmit(handleForm, handleError)}>
                            <div className="row my-3">
                                <div className="col-md">
                                    <label className='text-light'>Email</label>
                                    <div className="input-group">
                                        <span className="input-group-text"><i className="fa fa-envelope"></i></span>
                                        <input className="form-control" type="email" required placeholder='Enter your Email' {...register("email")} />
                                    </div>
                                </div>
                            </div>
                            <div className="row my-3">
                                <div className="col-md">
                                    <label className='text-light'>Password</label>
                                    <div className="input-group">
                                        <span className="input-group-text"><i className="fa fa-lock"></i></span>
                                        <input className="form-control" type="password" required placeholder='Enter Password' {...register("password")} />
                                    </div>
                                </div>
                            </div>
                            <div className="row my-4">
                                <div className="col-md">
                                    {
                                        !!loading ?
                                            <button className='btn btn-primary d-block mx-auto' type='button'>
                                                <Loader color={"white"} size={10} />
                                            </button>
                                            :
                                            <button type='submit' className="btn btn-primary d-block mx-auto">Submit</button>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
